module.exports = __webpack_public_path__ + "media/application/images/2018/consumer-peoples-choice-logo-6c11213ab5a69b6f2a88866918b99b41.png";